import qs from 'query-string';
import { MAX_LIMIT } from 'config';
import getCountryIds from 'helpers/getCountryIds';

const getBrowseCustomEntityListUrl = (args: any): string => {
  const {
    listId,
    salesType,
    customerFilter,
    sortOrder,
    sortby,
    countryIds,
    limit = MAX_LIMIT,
    offset = 0,
    nameFilter,
    region,
    media,
    customRegion,
  } = args;

  const params = qs.stringify({
    salesType,
    customerFilter,
    sortOrder,
    sortby,
    countryIds: getCountryIds(countryIds, region, customRegion),
    limit,
    offset,
    nameFilter,
    mediaTypes: media,
  });

  return `/api/browse/customEntityLists/${listId}?${params}`;
};

export default getBrowseCustomEntityListUrl;
